import React from 'react';
import './styles/PrivacyPolicy.css';

function ToDoPrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-content">
        <h1>To Do: Clean and Simple<br/>Privacy Policy</h1>
        
        <h2>Last Updated May 30, 2025</h2>
        
        <h3>Introduction</h3>
        <p>This Privacy Policy explains how "To Do: Clean and Simple" (we, our, the App) handles user data. We are committed to protecting your privacy and ensuring you have a positive experience using our open-source to-do application.</p>
        
        <h3>No Data Collection or Cloud Storage</h3>
        <p>The App is designed with privacy as a core principle. We do not collect, store, or transmit any user data to external servers. Specifically:</p>
        <ul>
          <li>We do not collect personal information</li>
          <li>We do not track user behavior or app usage</li>
          <li>We do not use analytics or crash reporting services</li>
          <li>We do not store any data on remote servers or in the cloud</li>
          <li>We do not share any data with third parties</li>
          <li>We do not require user accounts or registration</li>
        </ul>
        
        <h3>Local Storage Only</h3>
        <p>All your tasks, preferences, and app data are stored locally on your device using AsyncStorage. This means:</p>
        <ul>
          <li>Your data never leaves your device</li>
          <li>We cannot access your tasks or personal information</li>
          <li>Your data is only accessible to you through the app on your device</li>
          <li>If you uninstall the app, all data is permanently deleted from your device</li>
        </ul>
        
        <h3>Open Source Transparency</h3>
        <p>The App is open source software. This means:</p>
        <ul>
          <li>The complete source code is publicly available for review</li>
          <li>Anyone can verify our privacy practices by examining the code</li>
          <li>The app's functionality is transparent and auditable</li>
          <li>There are no hidden features or backdoors</li>
        </ul>
        
        <h3>Theme and Preferences</h3>
        <p>Your theme preferences (light/dark mode) and other app settings are stored locally on your device and are not transmitted anywhere.</p>
        
        <h3>Data Portability</h3>
        <p>Since all data is stored locally on your device, you have complete control over your information. However, please note that backing up or transferring your data is your responsibility as we do not provide cloud sync services.</p>
        
        <h3>Changes to Privacy Policy</h3>
        <p>We may update this Privacy Policy from time to time to reflect changes in the app or legal requirements. We will notify users of any material changes through app updates and by updating the "Last Updated" date at the top of this policy.</p>
        
        <h3>Contact Information</h3>
        <p>The App is an open-source project. For questions regarding this Privacy Policy or the app, please:</p>
        <ul>
          <li>Visit our GitHub repository to review the source code</li>
          <li>Open an issue on GitHub for technical questions or concerns</li>
          <li>Contact the maintainer for privacy-related inquiries</li>
        </ul>
        
        <h3>Your Rights</h3>
        <p>Since we do not collect any data about you:</p>
        <ul>
          <li>There is no personal data to access, modify, or delete on our end</li>
          <li>You have complete control over your local data</li>
          <li>You can delete all app data by uninstalling the application</li>
        </ul>
      </div>
    </div>
  );
}

export default ToDoPrivacyPolicy;
